import { channels } from "../../../../data/app__channels";

import packageseDRSP from "../../../../data/app__packages--DRSP.js";
import packagesAWSMembers from "../../../../data/app__packages--aws-personalmarketing-members.js";
import packagesAWS from "../../../../data/app__packages--aws-personalmarketing.js";
import packageseEmplify from "../../../../data/app__packages--emplify.js";
import packagesPhrase from "../../../../data/app__packages--phrase.js";
import packagesScheerer from "../../../../data/app__packages--scheerer.js";
import packageseYield from "../../../../data/app__packages--yield.js";
import logger from "../../../../utils/LoggerFrontend";
import _ from "lodash";

const allAWSPackages = packagesAWS.concat(packagesAWSMembers);

export const getSelectedChannelsList = (packageId, lifeTimeBudget, selectedChannels) => {
  logger.debug("CampaignCreate:getSelectedChannelsList", "NEW called...", {
    selectedChannels,
    lifeTimeBudget,
    packageId
  });
  const selectedChannel = selectedChannels.slice();

  if (
    packageId.includes("individuell") ||
    packageId.includes("std--") ||
    packageId.includes("jap-feed")
  ) {
    selectedChannel.push(_.find(channels, { channel_short_name: "facebook" }));
    selectedChannel.push(_.find(channels, { channel_short_name: "instagram" }));

    if (lifeTimeBudget >= 800) {
      selectedChannel.push(_.find(channels, { channel_short_name: "google-display" }));
    }
    return _.uniqBy(selectedChannel, "channel_short_name");
  }

  if (packageId.includes("scheerer")) {
    return _.find(packagesScheerer, { id: packageId }).selectedChannels;
  }

  if (packageId.includes("phrase")) {
    return _.find(packagesPhrase, { id: packageId }).selectedChannels;
  }

  if (packageId.includes("aws")) {
    return _.find(allAWSPackages, { id: packageId }).selectedChannels;
  }

  if (packageId.includes("emplify")) {
    return _.find(packageseEmplify, { id: packageId }).selectedChannels;
  }

  if (packageId.includes("drsp")) {
    return _.find(packageseDRSP, { id: packageId }).selectedChannels;
  }

  if (packageId.includes("yield")) {
    return _.find(packageseYield, { id: packageId }).selectedChannels;
  }

  logger.debug("CampaignCreate:getSelectedChannelsList", "called...", {
    selectedChannel,
    lifeTimeBudget
  });

  return selectedChannel;
};
